import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./ClientsCreatePhoneClientModal.module.css";
import { getConfig } from "../../../../config";
import { PhoneCodeSelect } from "../../../ui/PhoneCodeSelect/PhoneCodeSelect";

const ClientsCreatePhoneClientModal = ({ setIsOpen, setIsOpenClientsInfoModal, setPhoneNumber, clientDefaults }) => {
    const { t } = useTranslation();

    const phonePrefix = getConfig().cityCode === "UAE" ? "+971" : "+995";
    const defaultCode = clientDefaults?.phoneCode || phonePrefix;

    const [phoneCode, setPhoneCode] = useState(defaultCode);
    const [nationalNumber, setNationalNumber] = useState("");
    const [validationError, setValidationError] = useState("");

    const onSubmit = (e) => {
        e.preventDefault();
        const digits = nationalNumber.replace(/\D/g, "");
        const full = `${phoneCode}${digits}`;
        const phoneRegex = /^\+\d{7,15}$/;
        if (!phoneRegex.test(full)) {
            setValidationError(t("Please enter a valid phone number"));
            return;
        }
        setValidationError("");
        setPhoneNumber(full);
        setIsOpenClientsInfoModal(true);
        setIsOpen(false);
    };

    return (
        <div className={css.overlay} onClick={() => setIsOpen(false)}>
            <div className={css.modal} onClick={(e) => e.stopPropagation()}>

                <div className={css.header}>
                    <div className={css.headerIcon}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                            <circle cx="12" cy="7" r="4"/>
                        </svg>
                    </div>
                    <div>
                        <h2 className={css.title}>{t("create-client")}</h2>
                        <p className={css.subtitle}>{t("Enter the client's phone number to get started")}</p>
                    </div>
                    <button className={css.closeBtn} type="button" onClick={() => setIsOpen(false)} aria-label="Close">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                    </button>
                </div>

                <form onSubmit={onSubmit} className={css.form}>
                    <div className={css.fieldGroup}>
                        <label className={css.label}>{t("phone")}</label>
                        <div className={css.phoneRow}>
                            <div className={css.phoneCode}>
                                <PhoneCodeSelect
                                    value={phoneCode}
                                    onChange={(val) => {
                                        setPhoneCode(val || phonePrefix);
                                        setValidationError("");
                                    }}
                                />
                            </div>
                            <input
                                type="tel"
                                className={`${css.nationalInput}${validationError ? ` ${css.inputError}` : ""}`}
                                placeholder="50 123 4567"
                                value={nationalNumber}
                                autoFocus
                                onChange={(e) => {
                                    setNationalNumber(e.target.value.replace(/[^\d\s-]/g, ""));
                                    setValidationError("");
                                }}
                            />
                        </div>
                        {validationError && (
                            <p className={css.errorMsg}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                                {validationError}
                            </p>
                        )}
                        <p className={css.hint}>
                            {t("Full number")}: <strong>{phoneCode}{nationalNumber.replace(/\D/g, "") || "—"}</strong>
                        </p>
                    </div>

                    <div className={css.actions}>
                        <button type="button" className={css.cancelBtn} onClick={() => setIsOpen(false)}>
                            {t("modal-cancel")}
                        </button>
                        <button type="submit" className={css.submitBtn}>
                            {t("button-create-text")}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export { ClientsCreatePhoneClientModal };
